<template>

    <b-card-body class="submenu">
      <b-card-text>
        <ul>
          <li v-for="item in itens" :key="item.name" @click="hideSidebar">
            <router-link :to="item.url" v-if="!item.children">{{item.name}}</router-link>


              <b-card-header header-tag="header" role="tab" v-if="item.children">
                  <b-button
                          block
                          v-b-toggle="'accordion-' + item.name"
                          variant="link"
                          class="has-children"
                  >
                      <span v-if="item.children" class="menu-label menu-inner">{{ item.name }}</span>
                      <b-badge v-if="item.badge" pill :variant="item.badge.variant">{{
                          item.badge.descricao
                          }}</b-badge>
                  </b-button>
              </b-card-header>
              <b-collapse
                      :id="'accordion-' + item.name"
                      :accordion="item.name"
                      role="tabpanel"
                      v-if="item.children"
              >
                  <b-card-body class="submenu">
                      <b-card-text>
                          <ul style="list-style-type: none;">
                              <li v-for="child in item.children" :key="child.name" @click="hideSidebar" style="margin-left: 1rem;">
                                  <router-link :to="child.url" v-if="!child.children">{{child.name}}</router-link>
                              </li>
                          </ul>
                      </b-card-text>
                  </b-card-body>
              </b-collapse>
          </li>
        </ul>
      </b-card-text>
    </b-card-body>
</template>

<script>
import { mediaBreakpoint } from '@/assets/defs.js'
import SubItem from './SubItem'
export default {
    components: {
        SubItem
    },
  props: {
    itens: Array
  },
  methods: {
    hideSidebar () {
      if (screen.width <= mediaBreakpoint.sm) {
        this.$store.commit('setSidebar', 'sidebar-contracted')
      }
    }
  }

}
</script>

<style>
</style>
